import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";

const prodConfig = {
  apiKey: "AIzaSyAMooR3Cb2He9DR7waeMvPydl19deFiQGE",
  authDomain: "delagros-firmados.firebaseapp.com",
  projectId: "delagros-firmados",
  storageBucket: "delagros-firmados.appspot.com",
  messagingSenderId: "293071394868",
  appId: "1:293071394868:web:b04a44fc7dbc7b9cdb5261"
};
const testConfig = {
    apiKey: "AIzaSyDNy45MytpnvXqShvniwbLIU6nnAKjKpig",
    authDomain: "firmados-pruebas.firebaseapp.com",
    projectId: "firmados-pruebas",
    storageBucket: "firmados-pruebas.firebasestorage.app",
    messagingSenderId: "823867774636",
    appId: "1:823867774636:web:77ec5f64d5822340157109"
};

const isTestEnv = window.location.hostname.includes("firma-pruebas");

export const firmadosConfig = isTestEnv? ({
    user: "firmados@delagros.com",
    pass: "pruebas!2025"
  }):
  ({
    user: "firmados@delagros.com",
    pass: "As3agro.2024"
  });

export const URL_SAVE_CERT=isTestEnv?
  'https://europe-southwest1-firmados-pruebas.cloudfunctions.net/save_cert_key':
  'https://europe-southwest1-delagros-firmados.cloudfunctions.net/save_cert_key';

export const firebaseConfig = isTestEnv ? testConfig: prodConfig;

export const app: any = initializeApp(firebaseConfig);
export const db = getFirestore(app);